<template>
  <b-modal
      ref="show-security-group-modal"
      :title="$t('groups.show_group_details.title')"
      ok-only
      size="lg"
  >
    <div v-if="isLoading" class="d-flex justify-content-center m-5">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{$t('state.loading')}}</span>
      </div>
    </div>
    <div v-if="!isLoading" class="question-details">
      <h4>{{ $t('roles.show_group_details.basic_data') }}</h4>
      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr>
              <th>{{ $t('roles.show_role_details.role_name') }}:</th>
              <td>{{ role.role }}</td>
            </tr>
            <tr>
              <th>{{ $t('roles.show_role_details.role_category') }}:</th>
              <td>{{ role.category }}</td>
            </tr>
            <tr>
              <th>{{ $t('roles.show_role_details.role_is_special') }}:</th>
              <td>{{ role.isSpecial }}</td>
            </tr>
            <tr>
              <th>{{ $t('roles.show_role_details.role_created_at') }}:</th>
              <td>{{ roleCreatedAt }}</td>
            </tr>
            <tr>
              <th>{{ $t('roles.show_role_details.role_updated_at') }}:</th>
              <td>{{ roleUpdatedAt }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  data() {
    return {
      isLoading: true,
      role: null,
      roleCreatedAt: null,
      roleUpdatedAt: null,
      roles: null
    }
  },
  methods: {
    openModal(roleName) {
      this.resetProperties();
      this.getRoleDetails(roleName);
      this.$refs['show-security-group-modal'].show();
    },
    getRoleDetails(roleName) {
      axios.get(`/api/role/${roleName}`)
        .then(resp => {
          this.role = resp.data;
          this.roleCreatedAt = moment(this.role.createdAt).format('YYYY-MM-DD, h:mm:ss a');
          this.roleUpdatedAt = moment(this.role.updatedAt).format('YYYY-MM-DD, h:mm:ss a');
          this.isLoading = false;
        });
    },
    resetProperties() {
      this.isLoading = true;
      this.group = null;
      this.groupCreatedAt = null;
      this.groupUpdatedAt = null;
      this.roles = null;
    }
  }
}
</script>
